import { render, staticRenderFns } from "./ElderResidentsByAge.vue?vue&type=template&id=6959bf88&scoped=true&"
import script from "./ElderResidentsByAge.vue?vue&type=script&lang=js&"
export * from "./ElderResidentsByAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6959bf88",
  null
  
)

export default component.exports